export default __webpack_public_path__ + "static/3Dmeet-logo-full-d823e9ffd5d21923bb163d2f7774e9f6.png";